import { client } from "@/utils/client";

export function addCountry(domain, country_id, country_name, avs_status, wwa_status, shsMode,client_type, token) {
    const data = {
        domain,
        country_id,
        country_name,
        avs_status,
        wwa_status,
        shsMode,
        client_type,
        token
    }
    return client({
        url: "/console/country",
        method: "post",
        data
    })
}
export function updateCountry(domain, country_id, country_name, avs_status, wwa_status, shs_mode,client_type, token) {
    const data = {
        domain,
        country_id,
        country_name,
        avs_status,
        wwa_status,
        shs_mode,
        client_type,
        token
    }
    return client({
        url: "/console/country",
        method: "put",
        data
    })
}
export function deleteCountry(country_id, client_type, token) {
    return client({
        url: "/console/country?country_id=" + country_id + "&client_type=" + client_type + "&token=" + token,
        method: "delete",
    })
}



//////////////////
// WEBPACK FOOTER
// ./src/api/country.js
// module id = null
// module chunks = 